// hooks/useTemplateData.js
import { ref } from 'vue';
import { getAppWordTemplatePage } from '@/request/hotspotTemplate';
import { sysDictGetAppSysDictList } from '@/request/aiPlanTask';
import { ElMessage, ElMessageBox } from 'element-plus';

export default function useTemplateData() {
  let selectedTypeArr = [
    { label: '官方', value: 3 },
    { label: '团队', value: 2 },
  ];

  const templateData = ref({
    trade: '',
    keyword: '',
    belong: 3,
    pageIndex: 1,
    pageSize: 100,
    total: 0,
    loading: false,
    data: [] as any[],
  });

  const templateType = ref([]);
  const tradeTypeDic = ref<{ label: string; value: string }[]>([]);
  const wordDataTypeDic = ref([]);

  const templateLoadFn = async () => {
    if (templateData.value.data?.length && templateData.value.data.length >= templateData.value.total) return;
    templateData.value.loading = true;
    try {
      let type = Array.isArray(templateType.value) && templateType.value.length ? templateType.value.join(',') : '';
      const res = await getAppWordTemplatePage({
        templateType: type,
        ...templateData.value,
      });
      const { code, data, msg } = res.data;
      if (code === 200 && data && data.total) {
        templateData.value.total = data.total;
        templateData.value.data = [...templateData.value.data, ...data.list];
      } else {
        templateData.value.pageIndex = 1;
        templateData.value.data = [];
      }
    } catch (error) {
      console.error('Load more error:', error);
    } finally {
      templateData.value.loading = false;
    }
  };

  const loadTemplateLoadFn = () => {
    templateData.value.pageIndex++;
    templateLoadFn();
  };

  const changeTemplateTypeFn = (newTemplateType) => {
    templateType.value = newTemplateType;
    templateData.value.pageIndex = 1;
    templateData.value.data = [];
    templateLoadFn();
  };

  const fetchWordDataTypeDic = () => {
    sysDictGetAppSysDictList({ dictCode: 'word_template_type' }).then((res) => {
      const { code, data, msg } = res.data;
      if (code === 200) {
        wordDataTypeDic.value = (data && data['word_template_type']) || [];
      }
    });
  };

  const fetchTradeTypeDic = () => {
    sysDictGetAppSysDictList({ dictCode: 'trade_type' }).then((res) => {
      const { code, data, msg } = res.data;
      if (code === 200) {
        tradeTypeDic.value = (data && data['trade_type']) || [];
        tradeTypeDic.value.unshift({ label: '全部', value: '' });
      }
    });
  };

  return {
    tradeTypeDic,
    templateData,
    selectedTypeArr,
    templateType,
    wordDataTypeDic,
    templateLoadFn,
    loadTemplateLoadFn,
    changeTemplateTypeFn,
    fetchWordDataTypeDic,
    fetchTradeTypeDic,
  };
}
